import { I_OptionsGetList } from 'types';
import { BaseXHR } from 'utils/axios';

export const getListNotificationApi = (payload: I_OptionsGetList) =>
  BaseXHR.$get('notification/gets', payload);
